import {useEffect} from 'react';
import styles from './BenefactorPointsAndRating.module.scss';
import {PropertyRow, ErrorModal, useErrorHandler} from '../../../../shared';
import {useBenefactorById} from '../../hooks';
import {Loader} from '@gravity-ui/uikit';

interface BenefactorPointsAndRatingProps {
  benefactorId: string | undefined;
}

export const BenefactorPointsAndRating = ({benefactorId}: BenefactorPointsAndRatingProps) => {
  const {handleError, isErrorModalOpen, errorInfo, handleClose} = useErrorHandler({
    resourceName: 'Рейтинг и баллы',
    title: 'Ошибка при получении данных рейтинга',
  });

  const {getBenefactorScoring} = useBenefactorById(benefactorId || '');
  const {data: scoringData, isLoading, error: scoringError} = getBenefactorScoring;

  useEffect(() => {
    if (scoringError) {
      handleError(scoringError as unknown as ApiError);
    }
  }, [scoringError, handleError]);

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Loader size="l" />
      </div>
    );
  }

  return (
    <section>
      <div className={styles.pointsAndRatingContainer}>
        <PropertyRow property="Очки" value={scoringData?.points ?? '-'} />
        <PropertyRow
          property="Множитель очков"
          value={scoringData?.pointsMultiplier ? `x${scoringData.pointsMultiplier}` : '-'}
        />
        <PropertyRow property="Позиция в рейтинге" value={scoringData?.ratingPosition ?? '-'} />
        <PropertyRow property="Уровень членства" value={'0'} />
        <PropertyRow property="Лига" value={'0'} />
      </div>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </section>
  );
};
